module.exports = __webpack_public_path__ + "static/media/BannerRegistroMobileES.ce9fb144.jpg";